export default __webpack_public_path__ + "static/media/documents.51dbc65c.jpg";